import type {
  ChatSortType,
  ChatType,
} from "@circle-react/types/CommunityBot/ChatSort";

import { ErrorBoundary } from "@/react/components/shared/ErrorPages/ErrorBoundary";
import { ChatError } from "@/react/components/Spaces/ChatSpace/Messenger/ChatError";

import { ChatListComponent } from "./ChatList";

export const ChatList = ({
  activeSort,
  activeChatType,
  activeAgent,
}: {
  activeSort: ChatSortType;
  activeChatType: ChatType;
  activeAgent: { name: string; id: number };
}) => (
  <ErrorBoundary renderFunc={ChatError}>
    <ChatListComponent
      activeSort={activeSort}
      activeChatType={activeChatType}
      activeAgent={activeAgent}
    />
  </ErrorBoundary>
);
